import { PropertyFilter, PropertyValueSet } from "@promaster-sdk/property";

export function matchesPropertyFilter(
  filterText: string | null | undefined,
  propertyValues: PropertyValueSet.PropertyValueSet = PropertyValueSet.Empty
): boolean {
  const normalizedFilter = filterText?.trim();
  if (!normalizedFilter) {
    return true;
  }

  const parsedFilter = PropertyFilter.fromString(normalizedFilter, () => undefined);
  if (!parsedFilter) {
    return false;
  }

  return PropertyFilter.isValid(propertyValues, parsedFilter);
}

export function isVisibleFromPropertyFilter(visibleFilter?: string | null): boolean {
  return matchesPropertyFilter(visibleFilter, PropertyValueSet.Empty);
}
